import axios from 'axios';

// In development use localhost, in production use relative path (proxied by nginx)
const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:4999/api';

const api = axios.create({
  baseURL: API_URL
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data);
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Temporarily disabled for debugging
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) =>
  api.post('/auth/login', { username, password });

export const getMe = () => api.get('/auth/me');

export const acceptTerms = () => api.post('/auth/accept-terms');

export const verifyInvite = (token) => api.get(`/auth/verify-invite/${token}`);

export const setupAccount = (token, password) =>
  api.post(`/auth/setup/${token}`, { password });

// Users
export const getUsers = () => api.get('/users');

export const getPendingInvites = () => api.get('/users/pending');

export const createUser = (userData) => api.post('/users', userData);

export const resendInvite = (id) => api.post(`/users/${id}/resend-invite`);

export const deleteUser = (id) => api.delete(`/users/${id}`);

export const updateAllowedViewers = (allowedViewers) =>
  api.put('/users/me/allowed-viewers', { allowedViewers });

export const changePassword = (newPassword) =>
  api.put('/users/me/password', { newPassword });

export const updateProfile = (data) =>
  api.put('/users/me/profile', data);

// Targets
export const getTargets = () => api.get('/targets');

export const getTarget = (id) => api.get(`/targets/${id}`);

export const createTarget = (data) => api.post('/targets', data);

export const updateTarget = (id, data) => api.put(`/targets/${id}`, data);

export const deleteTarget = (id) => api.delete(`/targets/${id}`);

// Proposals
export const getMyProposals = () => api.get('/proposals/my');

export const getPublicProposals = () => api.get('/proposals/public');

export const createProposal = (data) => api.post('/proposals', data);

export const joinProposal = (id, selectedAvailability) =>
  api.put(`/proposals/${id}/join`, { selectedAvailability });

export const completeProposal = (id, completedSuccessfully) =>
  api.put(`/proposals/${id}/complete`, { completedSuccessfully });

export const deleteProposal = (id) => api.delete(`/proposals/${id}`);

// Visits
export const createVisit = (data) => api.post('/visits', data);

export const getMyVisits = () => api.get('/visits/my');

export const getTargetVisits = (targetId) => api.get(`/visits/target/${targetId}`);

// Goals
export const getGoals = () => api.get('/goals');

export const createGoal = (data) => api.post('/goals', data);

export const updateGoal = (id, data) => api.put(`/goals/${id}`, data);

export const deleteGoal = (id) => api.delete(`/goals/${id}`);

export const completeGoal = (id) => api.put(`/goals/${id}/complete`);

export default api;
